import { defineTour } from '@lopettia/simul';

/**
 * Pre-Sales — pick up an assigned opportunity, walk the 9-step demo
 * studio, refine sections in the editor, publish. Mirrors
 * docs/manuals/07-pre-sales.md.
 */
export const preSalesTour = defineTour({
  name: 'Pre-Sales demo build',
  description:
    'Pre-Sales walks through assigned opportunities, builds a prospect demo '
    + 'in the 9-step studio, edits sections, and publishes.',
  steps: [
    {
      id: 'ps-assigned',
      kind: 'navigate',
      target: '[data-tour-id="nav-handoff-inbox"]',
      toUrl: '/handoff-inbox',
      prelude: { goto: '/dashboard' },
      message:
        '**Handoff inbox.** Every demo a Closer hands off to you lands here.',
      advanceOn: 'navigate',
    },
    {
      id: 'ps-new',
      kind: 'navigate',
      target: '[data-tour-id="nav-demos-new"]',
      toUrl: '/demos/new',
      message:
        'The **Demo studio** is a 9-step guided builder — prospect → context → '
        + 'value props → CTA.',
      advanceOn: 'navigate',
    },
    {
      id: 'ps-studio-progress',
      kind: 'info',
      target: '[data-tour-id="demo-studio-progress"]',
      message:
        'The progress rail shows where you are. You can jump back to any '
        + 'completed step.',
      advanceOn: 'manual',
    },
    {
      id: 'ps-editor',
      kind: 'info',
      target: '[data-tour-id="demo-editor-canvas"]',
      message:
        'After the studio, the **editor** lets you reorder, refine, or '
        + 'regenerate any section via the AI **Refine** action.',
      advanceOn: 'manual',
    },
    {
      id: 'ps-publish',
      kind: 'info',
      target: '[data-tour-id="demo-publish-cta"]',
      message:
        'Hit **Publish** to mint the prospect-facing URL. The Closer is '
        + 'notified the moment it goes live.',
      advanceOn: 'manual',
    },
  ],
});

export default preSalesTour;
